/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OperationResourceGroupModel {
    getFixupPrototypeFunction() { return OperationResourceGroupModel.fixupPrototype; }

    static newInstance(model: Partial<OperationResourceGroupModel>): OperationResourceGroupModel {
        let obj = Object.assign(new OperationResourceGroupModel(), model);
        OperationResourceGroupModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OperationResourceGroupModel>): OperationResourceGroupModel {
        if (!model) return null;
        return OperationResourceGroupModel.newInstance(<OperationResourceGroupModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OperationResourceGroupModel) {
        if (!obj) return;

        models.OperationResourceGroupModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OperationResourceGroupModel): boolean {
        Object.setPrototypeOf(obj, OperationResourceGroupModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count === undefined) {
            this.count = 0;
        }
    }

    /**
     * resource group name
     */
    resource_group: string;

    /**
     * total count details
     */
    count: number;

}
